import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const BoxIcon = styled.div.withConfig({
  displayName: "ColumnLayoutIcon__BoxIcon",
  componentId: "sc-3x8kv7-0"
})(({
  theme: _theme,
  width,
  height
}) => {
  const theme = _theme;
  return {
    flexGrow: width,
    backgroundColor: theme.color['fill-tertiary-default'],
    borderColor: theme.color['border-tertiary-default'],
    borderWidth: theme.borderWidth['100'],
    borderStyle: 'solid',
    height: `${height}px`,
    marginInline: theme.space['50']
  };
});
const ColumnLayoutIcon = ({
  columnWidths,
  height = 22
}) => /*#__PURE__*/_jsx(Flex, {
  display: "flex",
  justifyContent: "space-between",
  flexGrow: "1",
  margin: "0",
  children: columnWidths.map((width, index) => /*#__PURE__*/_jsx(BoxIcon, {
    width: width,
    height: height
  }, index))
});
export default ColumnLayoutIcon;